import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pendenciaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import { sortData } from '../common/table/sortHelper';

import { 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, setResolvida,
	getListaMotorista, getListaPlaca, getListaLog
} from './pendenciaActions';
import { 
	getLista as getListaPendenciaTipo
} from '../pendenciaTipo/pendenciaTipoActions';
import { 
	getLista as getListaSetor
} from '../setor/setorActions';

const columns = [{
    field: 'nome_status',
    type: 'text'
}, {
    field: 'nome_tipo',
    type: 'text'
}, {
    field: 'nome',
    type: 'text',
    formatter: row => row.nome_motorista || row.cavalo || row.carreta || row.shipping
}, {
	field: 'obrigatoria',
    type: 'boolean'
}, {
	field: 'datahora_inclusao',
    type: 'date'
}, {
	field: 'data_maxima',
    type: 'date'
}, {
	field: 'datahora_resolvida',
    type: 'date'
}];

class Pendencia extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'datahora_inclusao',
			direction: 'asc'
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaPendenciaTipo();
		this.props.getListaSetor();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'resolver' ? (
						<Form resolver onSubmit={(registro) => this.props.setResolvida(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
		)
	}

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '')
					.split('+')
					.filter(p => p.trim())
					.some(pesquisar => `
						${item.nome_status}
						${item.nome_tipo}
						${item.nome_setor}
						${item.nome_motorista || item.cavalo || item.carreta || item.shipping}
						${item.obrigatoria ? 'Sim' : 'Não'}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}
						${DateFormat.formatarDataSqlParaTela(item.data_maxima)}
						${DateFormat.formatarDataHoraSqlParaTela(item.datahora_resolvida)}
					`.toUpperCase().includes(pesquisar.trim())
					);
		});

		return sortData(
			listaFiltrada,
			this.state.sort,
			columns
		);
	}

	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.filtrar();

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<InputPesquisa
							maxWidth={350}
							minWidth={350}
							cols='12 12 12 12'
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />
						
						<Select
							options={this.props.listaSetor}
							label='Setor'
							cols='12 1 1 1'
							minWidth={200}
							placeholder='Selecione'
							value={this.props.filtro.id_setor}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_setor: value
								});
							}} />
						
						<Select
							options={this.props.listaPendenciaTipo}
							label='Pendência'
							cols='12 1 1 1'
							minWidth={250}
							placeholder='Selecione'
							value={this.props.filtro.id_tipo}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_tipo: value
								});
							}} />

						<Select
							options={[{ id: 'aberta', valor: 'Abertas' }, { id: 'resolvida', valor: 'Resolvidas' }, { id: 'ambas', valor: 'Ambas' }]}
							label='Status'
							cols='12 1 1 1'
							minWidth={180}
							placeholder='Selecione'
							value={this.props.filtro.id_status}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_status: value
								});
							}} />

						<div style={{ width: 470, marginTop: 8, marginLeft: 8 }}>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_controle_patio_ficha_tipo: 1 //Motorista
									});
									this.props.getListaLog(0);
								}}>
								<i class='fas fa-plus'></i> Motorista
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_controle_patio_ficha_tipo: 2 //Cavalo
									});
									this.props.getListaLog(0);
								}}>
								<i class='fas fa-plus'></i> Cavalo
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_controle_patio_ficha_tipo: 3 //Carreta
									});
									this.props.getListaLog(0);
								}}>
								<i class='fas fa-plus'></i> Carreta
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({
										id_controle_patio_ficha_tipo: null //Shipping
									});
									this.props.getListaLog(0);
								}}>
								<i class='fas fa-plus'></i> Shipping
							</a>

							<ExcelFile
								filename={'Pendências'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									obrigatoria: item.obrigatoria ? 'Sim' : 'Não',
									nome: item.nome_motorista || item.cavalo || item.carreta || item.shipping,
									datahora_inclusao: DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao),
									data_maxima: DateFormat.formatarDataSqlParaTela(item.data_maxima),
									datahora_resolvida: DateFormat.formatarDataHoraSqlParaTela(item.datahora_resolvida)
								}))} name='Pendências'>
									<ExcelColumn label='Status' value='nome_status' />
									<ExcelColumn label='Pendência' value='nome_tipo' />
									<ExcelColumn label='Setor' value='nome_setor' />
									<ExcelColumn label='Nome / Placa / Shipping' value='nome' />
									<ExcelColumn label='Obrigatória' value='obrigatoria' />
									<ExcelColumn label='Abertura' value='datahora_inclusao' />
									<ExcelColumn label='Data Máxima' value='data_maxima' />
									<ExcelColumn label='Resolvida' value='datahora_resolvida' />
								</ExcelSheet>
							</ExcelFile>

						</div>
					</Row>

					<Table responsive border striped alturaFixa
						maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
							window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
								: (
									window.innerWidth < 1799
										? `${window.innerHeight - 180}px`
										: (
											window.innerWidth < 4000
												? `${window.innerHeight - 180}px`
												: `${window.innerHeight - 110}px`
										)
								)
						)}>
						<THead>
							<Tr backgroundColor={'#1F3066'}
								color={'#ffffff'}
								height={47}>
								
								<ThSort
									field='nome_status'
									label='Status'
									width={100}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
									
								<ThSort
									field='nome_tipo'
									label='Pendência'
									width={200}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />		

								<ThSort
									field='Setor'
									label='Setor'
									width={100}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />		

								<ThSort
									field='nome'
									label='Nome / Placa / Shipping'
									width={300}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />		

								<ThSort
									field='obrigatoria'
									label='Obrigatória'
									width={10}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />		
									
								<ThSort
									field='datahora_inclusao'
									label='Abertura'
									width={100}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />		

								<ThSort
									field='data_maxima'
									label='Data Máxima'
									width={100}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />
									
								<ThSort
									field='datahora_resolvida'
									label='Resolvida'
									width={100}
									sticky
									sort={this.state.sort}
									onSort={field => this.onSort(field)} />								

								<Th paddingTop={2} paddingBottom={2} sticky backgroundColor={'#1F3066'} color={'#ffffff'} width={100} alignCenter></Th>
							</Tr>
						</THead>
						<TBody>
							{lista.map((item, i) => {

								const setor = this.props.listaSetor.filter(setor => setor.id == item.id_setor)[0] || {};

								return (
									<Tr key={item.id}
										backgroundColor={this.state.linhaSelecionada == item.id ? '#bcc7eb' : (i % 2 == 0 ? '#ffffff' : '#f5f5f5')}
										onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
										<Td color={'#000'} alignCenter small>{item.nome_status}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_tipo}</Td>
										<Td color={'#000'} alignCenter small>{item.nome_setor}</Td>
										<Td color={'#000'} alignCenter small>
											{item.nome_motorista || item.cavalo || item.carreta || item.shipping}
											{(!item.resolvida && item.dentro_patio) &&
											<div class={item.bloqueia_saida ? 'div-piscando' : ''} 
												style={{ color: item.bloqueia_saida ? '#b80300' : '#ff5e00', fontWeight: 'bold' }}>
												<i class='fas fa-exclamation-triangle'></i> No Pátio{item.bloqueia_saida ? ' - Bloqueio da Saída' : ''}
											</div>}
										</Td>
										<Td color={'#000'} alignCenter small>{item.obrigatoria ? 'Sim' : 'Não'}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataSqlParaTela(item.data_maxima)}</Td>
										<Td color={'#000'} alignCenter small>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_resolvida)}</Td>
										<Td minWidth={50} width={100} alignCenter>
											{['USUARIO', 'SUPERVISOR', 'GESTOR'].includes(setor.permissao) &&
											<ButtonTable
												type={'warning'}
												icon={'fas fa-pencil-alt'}
												visible={true}
												small
												event={() => {
													this.props.setModoTela('cadastro', {
														...item
													});
													this.props.initForm({
														...item
													});
													this.props.getListaLog(item.id);
												}} />}
											
											{['USUARIO', 'SUPERVISOR', 'GESTOR'].includes(setor.permissao) &&
											<ButtonTable
												type={'success'}
												icon={item.resolvida ? 'fas fa-undo' : 'fas fa-check'}
												visible={!item.resolvida || ['SUPERVISOR', 'GESTOR'].includes(setor.permissao)}
												small
												title={item.resolvida ? 'Reabrir' : 'Resolvida'}
												event={() => {
													this.props.setResolvida({
														...item
													});
												}} />}

											{['SUPERVISOR', 'GESTOR'].includes(setor.permissao) &&
											<ButtonTable
												type={'danger'}
												icon={'fas fa-trash-alt'}
												visible={!item.resolvida}
												small
												event={() => {
													this.props.setModoTela('exclusao', {
														...item
													});
													this.props.initForm({
														...item
													});
													this.props.getListaLog(item.id);
												}} />}
										</Td>
									</Tr>
								);
							})}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.pendencia.aguardando,
	modoTela: state.pendencia.modoTela,
	lista: state.pendencia.lista.filter(item => {
		const setor = state.setor.listaSelect.filter(setor => setor.id == item.id_setor)[0];

		return setor && (
			(setor.ids_usuarios_completo || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id)
		);
	}),
	filtro: state.pendencia.filtro,
	listaPendenciaTipo: state.pendenciaTipo.listaSelect.filter(item => {
		const setor = state.setor.listaSelect.filter(setor => setor.id == item.id_setor)[0];

		return setor && (
			(setor.ids_usuarios_completo || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id)
			|| (setor.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id)
		);
	}),
	listaSetor: state.setor.listaSelect.filter(item => {
		return (item.ids_usuarios_completo || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id)
			|| (item.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id);
	}).map(item => ({
		...item,
		permissao: (item.ids_usuarios_gestores_completo || []).includes(state.auth.usuario.id) ? 'GESTOR' : (
			(item.ids_usuarios_supervisores_completo || []).includes(state.auth.usuario.id) ? 'SUPERVISOR' : (
				(item.ids_usuarios_completo || []).includes(state.auth.usuario.id) ? 'USUARIO' 
				: 'SEM PERMISSAO'
			)
		)
	}))
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, setResolvida,
	getListaMotorista, getListaPlaca, getListaPendenciaTipo, getListaSetor, getListaLog
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Pendencia);
